import * as React from 'react';
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import {RouteComponentProps} from "react-router";
import Routes from "../../navigation/route/Route";
import {withRouter} from "react-router-dom";
import AddJobForm from "./form/AddJobForm";
import {Boxed} from "../../hiberUiKit/src/molecules/Boxed/Boxed";

type Props = RouteComponentProps<any>;

class CreateJob extends React.Component<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create new job"}/>
				<PageContentView>
					<AddJobForm onSuccess={this.onSuccess}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added contact.
	 */
	private onSuccess() {
		this.props.history.push(Routes.JobsList);
	}
}

export default withRouter(CreateJob);